var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal", class: { "is-active": _vm.isOpen } },
    [
      _c("div", { staticClass: "modal-background" }),
      _c("div", { staticClass: "modal-card", style: _vm.size }, [
        _c("header", { staticClass: "modal-card-head" }, [
          _c("p", { staticClass: "modal-card-title" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _c("button", {
            staticClass: "delete",
            attrs: { "aria-label": "close" },
            on: { click: _vm.close }
          })
        ]),
        _c(
          "section",
          { staticClass: "modal-card-body" },
          [_vm._t("content"), _c("nuxt-child"), _c("nuxt")],
          2
        ),
        _c(
          "footer",
          { staticClass: "modal-card-foot" },
          [
            _vm._t("action", [_vm._v(" ")]),
            _c(
              "button",
              {
                staticClass: "button",
                staticStyle: { "margin-left": "10px" },
                on: { click: _vm.close }
              },
              [_vm._v("Cancel")]
            )
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f226802", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f226802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/modal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0f226802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/modal.vue
// module chunks = 0 1 2 3 29 42